// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotPassword .fieldset legend {
  font-size: 28px;
  margin-bottom: 10px;
}
.forgotPassword input {
  display: block;
  margin: 0 auto 0 auto;
  padding-left: 10px;
  border: 1px solid #c3cad4;
  width: 288px;
  max-width: 288px;
  height: 36px;
  border-radius: 8px;
  background-color: #f8f7f3;
}
@media (max-width: 599px) {
  .forgotPassword .fieldset legend {
    font-size: 21px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/password/ForgotPassword.less"],"names":[],"mappings":"AAEA;EAEE,eAAA;EACA,mBAAA;AAFF;AADA;EAME,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAFF;AAKC;EAAA;IAEE,eAAA;EAHD;AACF","sourcesContent":["@import (reference) '../../constants.less';\n\n.forgotPassword {\n\t.fieldset legend{\n\t\tfont-size: 28px;\n\t\tmargin-bottom: 10px;\n\t}\n\tinput {\n\t\tdisplay: block;\n\t\tmargin: 0 auto 0 auto;\n\t\tpadding-left: 10px;\n\t\tborder: 1px solid #c3cad4;\n\t\twidth: @inputWidth;\n\t\tmax-width: @inputWidth;\n\t\theight: 36px;\n\t\tborder-radius: 8px;\n\t\tbackground-color: @fieldBackgroundWhite;\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t.fieldset legend {\n\t\t\tfont-size: 21px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
